import request from "@/utils/request";
import { downloadExcel } from "@/utils/util";

export const exportUser = function(data) {
    //房客导出
    return request({
        method: "POST",
        url: "/develop/customer/ExportTenant",
        headers: {
            'Content-Type': 'application/json'
        },
        data
    }).then(result => {
        console.log(result)
        downloadExcel({
            fileName: result.data.msg,
            delete: true
        })
    })
};

export const ExportTenant = function(data) {
    //房东导出
    return request({
        method: "POST",
        url: "/develop/hourseLoad/ExportTenant",
        headers: {
            'Content-Type': 'application/json'
        },
        data
    }).then(result => {
        console.log(result)
        downloadExcel({
            fileName: result.data.msg,
            delete: true
        })
    })
}

export const exportVip = function(data) {
    //会员导出
    return request({
        method: "POST",
        url: "/vip/exportVipExcel",
        headers: {
            'Content-Type': 'application/json'
        },
        data
    }).then(result => {
        console.log(result)
        downloadExcel({
            fileName: result.data.msg,
            delete: true
        })
    })
}



export const exportVipApplyExcel = function(data) {
    //审核列表导出
    return request({
        method: "POST",
        url: "/vip/exportVipApplyExcel",
        headers: {
            'Content-Type': 'application/json'
        },
        data
    }).then(result => {
        console.log(result)
        downloadExcel({
            fileName: result.data.msg,
            delete: true
        })
    })
}